var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormField',[_c('Checkbox',{attrs:{"label":_vm.$t('map.general.subAreas'),"type":"switch"},model:{value:(_vm.label),callback:function ($$v) {_vm.label=$$v},expression:"label"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }